'use strict';

export let UsuariosComponentRoute = {
    selector: 'usuarioRoute',
    template: require('./usuario-route.html'),
    controller: class {

        /*@ngInject*/
        constructor(User) {
            // Use the User $resource to fetch all users
            this.listadoUsuarios = User.query();
        }

        delete(user) {
            user.$remove();
            this.listadoUsuarios.splice(this.listadoUsuarios.indexOf(user), 1);
        }

        toggleUsuario(item, status){
            item.active = status;
        }
    }
};



// WEBPACK FOOTER //
// ./client/app/usuario-route/usuario-route.component.js